module.exports = __webpack_public_path__ + "static/img/2_8_1.f6e28bd4.jpg";